var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMoreOptionsGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 11.7852C15.7704 11.7852 14.875 10.8897 14.875 9.78516C14.875 8.68059 15.7704 7.78516 16.875 7.78516C17.9796 7.78516 18.875 8.68059 18.875 9.78516C18.875 10.8897 17.9796 11.7852 16.875 11.7852ZM16.875 18.0002C15.7704 18.0002 14.875 17.1047 14.875 16.0002C14.875 14.8956 15.7704 14.0002 16.875 14.0002C17.9796 14.0002 18.875 14.8956 18.875 16.0002C18.875 17.1047 17.9796 18.0002 16.875 18.0002ZM14.875 22.2152C14.875 23.3197 15.7704 24.2152 16.875 24.2152C17.9796 24.2152 18.875 23.3197 18.875 22.2152C18.875 21.1106 17.9796 20.2152 16.875 20.2152C15.7704 20.2152 14.875 21.1106 14.875 22.2152Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoreOptionsGreen);
export default __webpack_public_path__ + "static/media/ico_more_options_green.609625a79fb9079ca806d17d4be91cc7.svg";
export { ForwardRef as ReactComponent };